import { useCallback, useState } from 'react';

export const useIsOpen = (initialValue = false) => {
	const [open, setOpen] = useState(initialValue);

	const on = useCallback(() => setOpen(true), []);

	const off = useCallback(() => setOpen(false), []);

	const toggle = useCallback(() => setOpen((prev) => !prev), []);

	return {
		open,
		on,
		off,
		toggle,
	};
};
